import { createReducer, on } from '@ngrx/store';

import {
  fetchHomeItemDetailSuccessAction,
  clearHomeItemDetail,
} from '@app/modules/home-item-detail/store/actions/home-item-detail.actions';
import { HomeItemDetail } from '@app/modules/home-item-detail/entities/home-item-detail';

export const initialState: HomeItemDetail = {} as HomeItemDetail;

export const homeItemDetailReducer = createReducer(
  initialState,
  on(fetchHomeItemDetailSuccessAction, (state, { response }) => {
    return response;
  }),
  on(clearHomeItemDetail, (status) => {
    return {} as HomeItemDetail;
  })
);
